<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-table v-model="data" class="comparative-table">
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell>{{ item.name }}</md-table-cell>
          <md-table-cell :class="getCellClass(item.column1, item)">{{ item.column1 }}</md-table-cell>
          <md-table-cell :class="getCellClass(item.column2, item)">{{ item.column2 }}</md-table-cell>
          <md-table-cell :class="getCellClass(item.column3, item) + ' hide-960'">{{ item.column3 }}</md-table-cell>
          <md-table-cell :class="getCellClass(item.column4, item) + ' hide-960'">{{ item.column4 }}</md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'comparative-table',
  props: ['data'],
  data() {
    return {
    }
  },
  methods: {
    getCellClass(val1, item){
      if (val1 == '')
        return 'no-borders';

      switch (item.name){
      case 'Margen Bruto' : (val1 == item.max) ? 'max-value' : ''; break;
      case 'Margen Neto' : (val1 == item.max) ? 'max-value' : ''; break;
      case 'Rentablidad' : (val1 == item.min) ? 'max-value' : ''; break;
      case 'Rinde de Equilibrio' : (val1 == item.min) ? 'max-value' : ''; break;
      case 'Precio de Equilibrio' : (val1 == item.min) ? 'max-value' : ''; break;
      case 'Inversión' : (val1 == item.min) ? 'max-value' : ''; break;
      case 'Ciclo' : (val1 == item.min) ? 'max-value' : ''; break;
      case 'Costo de cultivo' : (val1 == item.min) ? 'max-value' : ''; break;
      }
    }
  }
}
</script>
<style>
.comparative-table{
  margin-top:10px;
  width: 100%;
}
.comparative-table thead{
  display:none
}
.comparative-table td:first-child{
  width:20%
}
.comparative-table .md-table-cell-container .md-button{
  width: auto;
  float:left;
  margin-right: 5px;
}

.comparative-table .md-table-cell{
  border:  1px solid #ddd;
  background-color: #f2f2f2;
  text-align: center;

}
.comparative-table td{
  width: 20%;
}

.select-table {
  width: 100%
}

.select-table td{
  width: 20%;
  text-align: center
}
.comparative-table{
  display: block;
}

.comparative-table .max-value{
  background-color: #28ADC4;
  color:white;
  font-weight: bold;
}

.comparative-table .no-borders{
  border:none !important
}

.comparative-table .md-table-row:hover{
  background-color: #F2F2F2;
  color: #000 !important;

}
@media only screen and (max-width: 960px) {
  .hide-960{
    display: none
  }
}
@media only screen and (max-width: 960px) {
  .md-table-cell-container{
    font-size: 12px;
  }
}


</style>
